import { render, staticRenderFns } from "./sendMoment.vue?vue&type=template&id=1ae23481&"
import script from "./sendMoment.vue?vue&type=script&lang=js&"
export * from "./sendMoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports